import styled from 'styled-components';
import { paddings } from 'core/styles/GlobalStyles';
import { device, typographyMobile } from 'core/styles/variables';
import { AlertVariant, getAlertBorderColor } from 'core/utils';

export const AlertWrapperDiv = styled.div`
  margin: ${paddings.smallPadding} 0;
`;

export const IconWrapperDiv = styled.span`
  width: 24px;
  margin: 0 ${paddings.defaultPadding} -${paddings.mediumSmallPadding} ${paddings.smallPadding};
  @media ${device.lg} {
    margin-right: ${paddings.defaultPadding};
  }
`;

export const BannerDiv = styled.div<{ $variant: AlertVariant }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${paddings.tinyPadding} ${paddings.smallPadding};
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme, $variant }) => getAlertBorderColor(theme, $variant)};
  border-radius: 12px;
  min-height: 45px;
`;

export const MessageWrapperDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  :last-child {
    margin-right: 8px;
  }
  @media ${device.xs} {
    align-items: center;
  }
`;

export const MessageDiv = styled.div`
  color: ${({ theme }) => theme.colors.onSurface};
`;

export const ChildrenContainerDiv = styled.div`
  margin: 0;
  font-size: ${typographyMobile.size.tiny};
  text-align: right;
  padding: ${paddings.smallPadding} 0 0 45px;

  div {
    padding-bottom: ${paddings.tinyPadding};
  }
`;

export const ActionButtonDiv = styled.div`
  display: flex;
  align-items: center;
  & button {
    color: ${({ theme }) => theme.colors.orange600};
  }
  > :not(:last-child) {
    margin-right: ${paddings.defaultPadding};
  }
  margin-left: ${paddings.defaultPadding};
`;

export const BannerContentDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
